import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { Alert } from "@material-ui/lab";
import { Button } from "@material-ui/core";
import { useHistory, useLocation } from "react-router-dom";
import useStyles from "./ChangePasswordAlert.style";
import { messages } from "./ChangePasswordAlert.messages";
import { useAuthenticatedUser } from "../../Providers/AuthenticatedUserProvider/AuthenticatedUserProvider";
import { RoutePath } from "../Routes/RoutePath";
import FeatureController from "../FeatureController/FeatureController";
import { UserRoleType } from "../../generated/user-api";
import { CustomerFeatureType } from "../../generated/customersettings-api";
import LocationController from "../LocationController/LocationController";

const ChangePasswordAlert = () => {
  const intl = useIntl();
  const history = useHistory();
  const location = useLocation();
  const classes = useStyles();
  const [authenticatedUser] = useAuthenticatedUser();
  const [isOpen, setIsOpen] = useState(false);

  const redirectToUsernamePasswordSettings = () => {
    history.push(RoutePath.ACCOUNT_TAB_USERNAME_PASSWORD);
    if (location.pathname === RoutePath.ACCOUNT) {
      window.location.reload();
    }
  };

  const handleCloseAlert = () => {
    setIsOpen(false);
  };

  const handleOnClick = () => {
    setIsOpen(false);
    redirectToUsernamePasswordSettings();
  };

  const getRequiredFeatureForRole = (
    role: UserRoleType
  ): CustomerFeatureType => {
    switch (role) {
      case UserRoleType.Client:
        return CustomerFeatureType.UsernameLoginClient;
      case UserRoleType.Staff:
        return CustomerFeatureType.UsernameLoginStaff;
      case UserRoleType.External:
        return CustomerFeatureType.UsernameLoginExternal;
      default:
        return CustomerFeatureType.UsernameLoginStaff;
    }
  };

  useEffect(() => {
    if (authenticatedUser.user && authenticatedUser.user.hasActivatedPassword) {
      setIsOpen(authenticatedUser.user?.mustChangePassword);
    }
  }, [authenticatedUser.user?.mustChangePassword]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <LocationController
        invertCheck
        requiredAnyOfPaths={[
          RoutePath.ACCOUNT,
          RoutePath.ACCOUNT_TAB_USERNAME_PASSWORD,
        ]}
      >
        {isOpen &&
          authenticatedUser.isLoggedIn &&
          authenticatedUser.user?.userRole && (
            <FeatureController
              requiredFeature={getRequiredFeatureForRole(
                authenticatedUser.user?.userRole
              )}
            >
              <Alert
                className={classes.alert}
                severity="info"
                variant="filled"
                onClose={handleCloseAlert}
                hidden={isOpen}
              >
                {intl.formatMessage(messages.alertText)}
                <Button
                  className={classes.button}
                  color="inherit"
                  variant="outlined"
                  size="small"
                  onClick={handleOnClick}
                >
                  {intl.formatMessage(messages.alertButtonLabel)}
                </Button>
              </Alert>
            </FeatureController>
          )}
      </LocationController>
    </>
  );
};

export default ChangePasswordAlert;
